module.exports = __webpack_public_path__ + "img/slide.cc5e8cbe.png";